import { render, staticRenderFns } from "./setores-risco-editar-equipamento.vue?vue&type=template&id=042deb8f&"
import script from "./setores-risco-editar-equipamento.vue?vue&type=script&lang=js&"
export * from "./setores-risco-editar-equipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports